// extracted by mini-css-extract-plugin
var _1 = "TasksCell_addButton__81MqU";
var _2 = "TasksCell_iconAddButton__Co6Yr";
var _3 = "TasksCell_popupWrapper__U6SaR";
export { _1 as "addButton", _2 as "iconAddButton", _3 as "popupWrapper" }
